module.exports = __webpack_public_path__ + "img/BA_GenericEvent.85b6bc35.png";